import React from 'react';
import ColorPicker from '../../../../../../components/color-picker';
import Style from './colorInput.module.css';

export default function ColorInput({ label, value = 'black', onChange = () => {}, ...params }) {
    const [showModale, setShowModale] = React.useState(false);
    return (
        <div>
            <div className={Style['color-title']}>
                <div className={Style['color-viewer']} style={{ background: value?.toString() }} onClick={() => setShowModale(true)} />
                {label}
            </div>
            <ColorPicker
                color={value}
                value={value}
                disableAlpha
                show={showModale}
                onClickAway={() => setShowModale(false)}
                onChange={color => {
                    onChange(color.hex);
                }}
                {...params}
            />
        </div>
    );
}
